
(function documentTypeDefinition() {
    'use strict';
    angular.module('Entities')
        .service('adminDocumentTypeService', [
            'restUrlBuilder', 'config', function admindocumentTypeService(restUrlBuilder, config) {

                this.getById = function getById(id, levelOfDetail) {
                    var params = { lod: levelOfDetail };

                    return restUrlBuilder.one('adminDocumentTypes', id)
                        .get({ params: params });

                };

                this.getNotInRole = function (roleId) {
                    var params = { NotInRole: roleId, applicationId: config.appId() };
                    return restUrlBuilder.all('adminDocumentTypes')
                        .get({ params: params });
                };

                this.get = function get(name, organizationalUnitId) {

                    var params = { Name: name, OrganizationalUnitId: organizationalUnitId, applicationId: config.appId() };

                    return restUrlBuilder.all('adminDocumentTypes')
                        .get({ params: params });

                };

                this.getRoleDocumentTypes = function getRoleDocumentTypes(roleId) {

                    return restUrlBuilder.one('roles', roleId)
                                         .all('documentTypes')
                                         .get();

                };

                this.setRoleDocumentTypes = function setRoleDocumentTypes(roleId, documentTypes) {

                    return restUrlBuilder.one('roles', roleId)
                                         .all('DocumentTypes')
                                         .put(documentTypes);

                };
            }
        ]);
})();